import { EuiSwitch } from "@elastic/eui";
import { createUseStyles } from "react-jss";

type StyleProps = {
  color: string;
  checked: boolean;
};

const useStyles = createUseStyles<string, StyleProps>({
  switch: {
    "& .euiSwitch__body": {
      backgroundColor: ({ color, checked }) => (checked ? color : "#5A6D8C"),
    },
    "& .euiSwitch__thumb": {
      borderColor: ({ color, checked }) => (checked ? `${color} !important` : "#5A6D8C"),
    },
  },
});

type SwitchProps = {
  checked: boolean;
  label: string | any;
  color?: string;
  compressed?: boolean;
  isMini?: boolean;
  style?: any;
  onChange: (e: any) => void;
  disabled?: boolean;
};

const Switch = ({
  checked,
  onChange,
  label = "",
  color = "var(--button-bg)",
  compressed = false,
  disabled = false,
  style,
  isMini = false,
}: SwitchProps) => {
  const classes = useStyles({ color, checked });
  return (
    <EuiSwitch
      checked={checked}
      className={classes.switch}
      label={label}
      onChange={onChange}
      compressed={compressed}
      disabled={disabled}
      style={style}
      mini={isMini}
    />
  );
};

export default Switch;
